import React, { useEffect, useRef } from "react";
import { Formik } from "formik";

export function BranchCourseCustomizationFilter({ filterData, courseCodes }) {
  const formRef = useRef();

  useEffect(() => {
    if (formRef.current) {
      formRef.current.click();
    }
  }, [courseCodes]);

  return (
    <Formik
      initialValues={{
        courseCodeFilter: "",
        activeFilter: "1",
      }}
      onSubmit={(values) => {
        filterData({
          courseCode: values.courseCodeFilter,
          active: values.activeFilter,
        });
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-3">
              <select
                className="form-control"
                name="courseCodeFilter"
                onBlur={handleBlur}
                onChange={(e) => {
                  setFieldValue("courseCodeFilter", e.target.value);
                  handleSubmit();
                }}
                value={values.courseCodeFilter}
              >
                <option value="">All</option>
                {courseCodes.map((c) => (
                  <option key={c.code} value={c.code}>
                    {c.code} - {c.name}
                  </option>
                ))}
              </select>
              <small className="form-text text-muted">
                <b>Filter</b> by Course Code
              </small>
            </div>
            <div className="col-lg-3">
              <select
                className="form-control"
                name="activeFilter"
                onBlur={handleBlur}
                onChange={(e) => {
                  setFieldValue("activeFilter", e.target.value);
                  handleSubmit();
                }}
                value={values.activeFilter}
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
                <option value="">All</option>
              </select>
              <small className="form-text text-muted">
                <b>Filter</b> by Status
              </small>
            </div>
            <button
              type="submit"
              ref={formRef}
              style={{ display: "none" }}
              onClick={handleSubmit}
            />
          </div>
        </form>
      )}
    </Formik>
  );
}
